module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-6.e21cf755.png";